import React, {Component} from 'react';
import {isEqual} from 'lodash';
import ChartComponent from './ChartComponent';

export default class DataChartComponent extends Component {
    constructor(props) {
        super(props);

        this.chartRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const previousData = prevProps.data;
        const newData = this.props.data;

        if (!isEqual(previousData, newData)) {
            if (this.chartRef && this.chartRef.current) {
                this.chartRef.current.updateData(newData);
            }
        }
    }

    render() {
        return (
            <ChartComponent ref={this.chartRef} type={this.props.type || 'bar'}/>
        );
    }
}
